<h3>Versions</h3>
<div *ngIf="!loading; else loadingEntry">
  <p>ProduceIT-UI-{{versions.ui}}</p>
  <p>ProduceIT-BE-{{versions.api}}</p>
  <p>ProduceIT-FN-{{versions.fn}}</p>
  <p><button class="button primary-button" data-test-id="version_refresh" (click)="updateVersions()">Refresh</button></p>
</div>
<ng-template #loadingEntry>
  <p>Loading versions...</p>
</ng-template>
